import HTTP from '@/api/HTTP';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

const URL_BASE = 'patri/Dispositif/';

export async function create(dispositifInformation) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', dispositifInformation);
  return response;
}

export async function get(idDispositif) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idDispositif } });
  return response;
}

export async function update(dispositifInformation) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', dispositifInformation);
  return response;
}

export async function updateNomenclatureDispositif(dispositifInformation) {
  const response = await HTTP.put(URL_BASE + 'UpdateNomenclatureDispositif', dispositifInformation);
  return response;
}

export async function getAll(param) {
  const inputServer = generalTransformer(param);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function remove(idDispositif) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: idDispositif } });
  return response;
}

export async function archiver(id, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAsync', { id: id, archiver: status });
  return response;
}

export async function changerEtat(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateAllEtatAsync', params);
  return response;
}

export async function archiverAll(ids, status) {
  const response = await HTTP.post(URL_BASE + 'ArchiverAllAsync', { ids: ids, archiver: status });
  return response;
}

export async function ajoutSecteurAsync(params) {
  const response = await HTTP.post(URL_BASE + 'AjoutSecteurAsync', params);
  return response;
}

export async function suppressionSecteurAsync(params) {
  const response = await HTTP.post(URL_BASE + 'SuppressionSecteurAsync', params);
  return response;
}

export async function genererDemandeImpression(demandeImpression) {
  const response = await HTTP.post(URL_BASE + 'GenererDemandeImpressionAsync', demandeImpression);
  return response;
}

export async function dupliquerAsync(id) {
  const response = await HTTP.post(URL_BASE + 'DupliquerAsync', { id: id });
  return response;
}

export async function deplacerAsync(params) {
  const response = await HTTP.post(URL_BASE + 'DeplacerAsync', params);
  return response;
}

export async function UpdateAllLogo(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateAllLogoAsync', params);
  return response;
}

export async function supprimer(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}
